<template lang="pug">
span.icon-holder(v-show="help" @mouseover="showToolTip = true" @mouseleave="showToolTip = false" )
  slot 
    BriqIcon(name="icon-help")
  div.tooltip-holder.type-small(v-show="showToolTip" :class="position") {{ help }}
</template>

<script>
export default {
  name: 'BriqTooltip',
  props: {
    help: {
      default: null,
    },
    position: { type: String, default: 'top-left' },
  },
  data() {
    return {
      showToolTip: false,
    }
  },
}
</script>

<style scoped lang="stylus">
.icon-holder
  position relative

.tooltip-holder
  width 200px
  padding 10px
  border 1px solid #D3D3D3
  position absolute
  background-color white
  z-index 2
  color #000E28
  font-weight normal
  border-radius 3px

  &:after
    content ''
    width 8px
    height 8px
    background-color #fff
    border-width 0px 1px 1px 0px;
    border-style solid
    border-color #D3D3D3
    display block
    position absolute
    z-index -1

.top-left
  bottom 25px
  left -11px

  &:after
    transform rotate(45deg)
    bottom -5px
    left 11px

.top-right
  bottom 25px
  left -174px

  &:after
    transform rotate(45deg)
    bottom -5px
    left 175px

.bottom-left
  top 26px
  left -11px

  &:after
    transform rotate(225deg)
    top -5px
    left 12px

.bottom-right
  top 26px
  left -176px

  &:after
    transform rotate(225deg)
    top -5px
    left 179px
</style>
